import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d6c1802&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/case_consult.css?vue&type=style&index=0&id=5d6c1802&prod&scoped=true&lang=css&external"
import style1 from "../../assets/css/case.css?vue&type=style&index=1&id=5d6c1802&prod&scoped=true&lang=css&external"
import style2 from "../../assets/css/chat.css?vue&type=style&index=2&id=5d6c1802&prod&scoped=true&lang=css&external"
import style3 from "./index.vue?vue&type=style&index=3&id=5d6c1802&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6c1802",
  null
  
)

export default component.exports